export default __webpack_public_path__ + "static/media/instagram.664453db.svg";